<script setup lang="ts">
import OrganisationTypeIcon from "@/components/OrganisationTypeIcon.vue";
import type { Organisation, Questionnaire } from "@/types";

export type FilterCriteria = {
  questionnaireId: Questionnaire["id"] | undefined;
  organisationType: Organisation["type"] | undefined;
};

const filterCriteria = defineModel<FilterCriteria>({ required: true });

const { questionnaires } = defineProps<{
  questionnaires: Questionnaire[];
}>();

const organisationTypeOptions: {
  name: string;
  value: Organisation["type"] | undefined;
}[] = [
  { name: "— Alle —", value: undefined },
  { name: "Hospital", value: "hospital" },
  { name: "Kommunal", value: "municipal" },
  { name: "Yder", value: "provider" }
] as const;
</script>

<template>
  <div>
    <div class="mb-3">
      <label for="questionnaire" class="form-label fw-semibold">Spørgeskema</label>
      <select id="questionnaire" v-model="filterCriteria.questionnaireId" class="form-select">
        <option :value="undefined">— Alle —</option>
        <option v-for="questionnaire in questionnaires" :key="questionnaire.id" :value="questionnaire.id">
          {{ questionnaire.name }}
        </option>
      </select>
    </div>
    <fieldset class="mb-3">
      <legend class="col-form-label pt-0 fw-semibold">Organisationstype</legend>
      <div
        v-for="(organisationType, index) in organisationTypeOptions"
        :key="organisationType.value"
        class="form-check d-flex gap-2"
      >
        <input
          :id="`organisation-type-${index}`"
          v-model="filterCriteria.organisationType"
          class="form-check-input"
          type="radio"
          :value="organisationType.value"
        />
        <label class="form-check-label d-flex align-items-center gap-1" :for="`organisation-type-${index}`">
          <OrganisationTypeIcon v-if="organisationType.value" class="flex-shrink-0" :type="organisationType.value" />
          {{ organisationType.name }}
        </label>
      </div>
    </fieldset>
  </div>
</template>
